import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm fhd:text-base font-medium ring-offset-background transition-[color,background-color,border-color,text-decoration-color,transform] duration-150 ease-out active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 disabled:active:scale-100 aria-disabled:active:scale-100 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground hover:bg-primary/90',
        destructive:
          'bg-destructive text-destructive-foreground hover:bg-destructive/90',
        outline:
          'border text-primary border-primary bg-background hover:bg-primary/5',
        secondary:
          'bg-secondary text-secondary-foreground hover:bg-secondary/80',
        ghost: 'hover:bg-accent hover:text-accent-foreground',
        link: 'text-primary underline-offset-4 hover:underline',
        soft: 'bg-teal-50 text-primary hover:bg-primary/10',
        teal: 'bg-teal-500 text-white hover:bg-teal-500/90',
      },
      size: {
        xxs: 'h-4 min-h-4 rounded-md px-1',
        xs: 'h-7 min-h-7 rounded-md px-2.5',
        sm: 'h-9 fhd:h-10 rounded-md px-3 fhd:px-4',
        md: 'h-10 fhd:h-11 px-4 fhd:px-5 py-2',
        lg: 'h-11 fhd:h-12 rounded-md px-8 fhd:px-10',
        'icon-sm': 'h-7 w-7 sm:h-8 sm:w-8 fhd:h-9 fhd:w-9',
        'icon-md': 'h-8 w-8',
        icon: 'h-9 w-9',
        'icon-lg': 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'sm',
    },
  },
);
